/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from 'react';

function AccessDeniedPage() {
  return (
    <div style={styles.accessDeniedContainer}>
      <h1  style={styles.accessDeniedNumber}>403</h1>
      <h2 style={styles.accessDeniedTitle}>Accés denegat</h2>
      <p style={styles.accessDeniedMessage}>
        Ho sentim, no tens permís per accedir a aquesta página.
      </p>
    </div>
  );
}

export default AccessDeniedPage;

// Estilos CSS para la página de acceso denegado
const styles = {
  accessDeniedContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#f8f8f8',
  },
  accessDeniedNumber:{
    fontSize: '148px',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  accessDeniedTitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  accessDeniedMessage: {
    fontSize: '16px',
    color: '#555',
    textAlign: 'center',
    maxWidth: '400px',
  },
};
